@if (!carregando) {
  <div class="pb-2" [@esvanecerDesvanecer]="'in'">
    <!-- Vendedor(a) -->
    <div class="form-row">
      <div class="form-group col-sm-12">
        <label><b>Vendedor(a):</b></label>
        <select class="form-control form-control-sm" name="vendedor" #vendedor (change)="selecionarVendedor(vendedor.value)">
          <option value="0" [selected]="vendedorSelecionado == null"></option>
          @for (opcao of vendedores; track opcao) {
            <option [value]="opcao.id" [selected]="vendedorSelecionado != null ? opcao.id == vendedorSelecionado.id : null">{{ opcao.fullname }}</option>
          }
        </select>
      </div>
    </div>
    <hr class="mt-2 mb-2" />
    <div class="crm">
      <div class="d-flex">
        @for (crmAgrupado of crmAgrupados; track crmAgrupado) {
          <div class="crm_funil">
            <!-- Cabeçalho (Funil) -->
            <div class="d-flex flex-column">
              <div class="crm_nome text-center">
                @if (crmAgrupado.nome_negocio == 'Ganhos') {
                  <b class="text-success">{{ crmAgrupado.nome_negocio }} ({{ crmAgrupado.negocios.length }})</b>
                }
                @if (crmAgrupado.nome_negocio == 'Perdas') {
                  <b class="text-danger">{{ crmAgrupado.nome_negocio }} ({{ crmAgrupado.negocios.length }})</b>
                }
                @if (crmAgrupado.nome_negocio != 'Ganhos' && crmAgrupado.nome_negocio != 'Perdas') {
                  <b>{{ crmAgrupado.nome_negocio }} ({{ crmAgrupado.negocios.length }})</b>
                }
              </div>
              <div class="crm_valor text-center text-secondary">
                <b>{{ crmAgrupado.valor_total_negocio | currency: 'BRL' }}</b>
              </div>
            </div>
            <div class="crm_area" dndEffectAllowed="move" (dndDrop)="onDrop($event, crmAgrupado.funnel_classification_id, crmAgrupado.ganhou_perdeu, crmAgrupado.nome_negocio, crmAgrupado.negocios)" dndDropzone>
              <div class="crm_destino" dndPlaceholderRef></div>
              <!-- Negócios -->
              @for (negocio of crmAgrupado.negocios; track negocio) {
                <div class="crm_negocio"
                  [dndDraggable]="negocio"
                  [dndEffectAllowed]="negocio.effectAllowed"
                  [dndDisableIf]="negocio.disable"
                  (dndStart)="onDragStart($event)"
                  (dndCopied)="onDragged(negocio, crmAgrupado.negocios, 'copy')"
                  (dndLinked)="onDragged(negocio, crmAgrupado.negocios, 'link')"
                  (dndMoved)="onDragged(negocio, crmAgrupado.negocios, 'move')"
                  (dndCanceled)="onDragged(negocio, crmAgrupado.negocios, 'none')"
                  (dndEnd)="onDragEnd($event)">
                  <div class="d-flex flex-column align-items-center">
                    <div>
                      <b>{{ negocio.name }}</b>
                    </div>
                    @if (negocio.responsible_name != '') {
                      <div>
                        <b>{{ negocio.responsible_name }} / {{ negocio.fullname }}</b>
                      </div>
                    }
                    @if (negocio.responsible_name == '') {
                      <div>
                        <b>{{ negocio.fullname }}</b>
                      </div>
                    }
                    <div>
                      <b>{{ negocio.valor_negocio | currency: 'BRL' }}</b>
                    </div>
                    <div class="crm_status">
                      @if (negocio.qtdeDias < 0) {
                        <span class="badge badge-danger">Atrasada {{ negocio.qtdeDias }} dia(s)</span>
                      }
                      @if (negocio.qtdeDias > 0) {
                        <span class="badge badge-primary">Futura {{ negocio.qtdeDias }} dia(s)</span>
                      }
                      @if (negocio.qtdeDias == 0) {
                        <span class="badge badge-warning">Hoje</span>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
